import type { ConfigureProps as BaseConfigureProps } from 'react-instantsearch';
import { Configure as BaseConfigure } from 'react-instantsearch';

import { useRouter } from '@/hooks/useRouter';
import { HITS_PER_PAGE } from '@/lib/const';

interface ExtendedConfigureProps extends Partial<BaseConfigureProps> {
  analyticsTags?: string[];
  distinct?: boolean;
  facetFilters?: string[];
  facetingAfterDistinct?: boolean;
  facets?: string[];
  filters?: string;
  hitsPerPage?: number;
  maxValuesPerFacet?: number;
  offset?: number;
  page?: number;
  query?: string;
  queryType?: 'prefixLast' | 'prefixAll' | 'prefixNone';
  typoTolerance?: boolean | 'min' | 'strict';
  userToken?: string;
}

export const Configure = (props: ExtendedConfigureProps) => {
  return <BaseConfigure {...(props as any)} />;
};

export const PaginatedConfigure = (props: ExtendedConfigureProps) => {
  const { query } = useRouter();
  const page = Number(query.page) || 1;

  // For page 1 or no page param, request normal amount
  // For page > 1, request cumulative results (all pages up to current)
  // This supports the "load more" pattern where new results extend the list
  const hitsPerPage = HITS_PER_PAGE * page;

  return <Configure hitsPerPage={hitsPerPage} offset={0} {...(props as any)} />;
};
